export default __webpack_public_path__ + "static/media/physiotherapist.ae87fd9b.svg";